import { isString } from './isString';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type MapFunction<T = unknown> = (value: T, index?: number, array?: T[]) => any;

export const groupBy = <T = unknown>(array: T[], fn: MapFunction<T> | string): Record<number | string | keyof T, T[]> =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  array.map(isString(fn) ? (value: any) => value[fn] : fn).reduce(
    (accumulator, value, index) => {
      accumulator[value] = (accumulator[value] ?? []).concat(array[index]);

      return accumulator;
    },
    {} as Record<keyof T, T>,
  );
